import type { PromotionCodeInfo } from '../../../types/rest-api';

/** Persists Bestellübersicht form values so users can navigate back to «Dein Angebot» without losing input. */
export const COMPLETE_ORDER_ONBOARDING_DRAFT_KEY =
  'bn_complete_order_onboarding_draft_v1';

export interface CompleteOrderOnboardingDraft {
  flow: 'municipality' | 'school';
  organizationName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  street: string;
  zipcode: string;
  city: string;
  taxId: string;
  promotionCode: string;
  promoInfo: PromotionCodeInfo | null;
  selectedDuration: 1 | 2 | 3;
  accepted: boolean;
}

export function saveCompleteOrderOnboardingDraft(
  draft: CompleteOrderOnboardingDraft
): void {
  try {
    sessionStorage.setItem(
      COMPLETE_ORDER_ONBOARDING_DRAFT_KEY,
      JSON.stringify(draft)
    );
  } catch {
    // sessionStorage may be unavailable (private mode quota); silently drop.
  }
}

export function loadCompleteOrderOnboardingDraft(): CompleteOrderOnboardingDraft | null {
  try {
    const raw = sessionStorage.getItem(COMPLETE_ORDER_ONBOARDING_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CompleteOrderOnboardingDraft;
  } catch {
    return null;
  }
}

export function clearCompleteOrderOnboardingDraft(): void {
  sessionStorage.removeItem(COMPLETE_ORDER_ONBOARDING_DRAFT_KEY);
}
